import React from 'react';
import { Result } from 'antd';
import { ActionsBar } from '@ydistri/ds';
import ManualCalculationImportAction from '../../actions/ManualCalculationImportAction';
import { CalculationDetailResponse } from '@ydistri/api-sdk';

interface SkuRedistributionNoDataMessageProps {
  calculation: CalculationDetailResponse;
}

const SkuRedistributionNoDataMessage: React.FC<SkuRedistributionNoDataMessageProps> = ({
  calculation,
}) => {
  return (
    <Result
      data-type="skuRedistributionPending"
      status="info"
      subTitle="There are no redistribution data, click the Import button below and import data"
      title="Please import data"
      extra={
        <ActionsBar>
          <ManualCalculationImportAction calculation={calculation} />
        </ActionsBar>
      }
    />
  );
};

export default SkuRedistributionNoDataMessage;
